// "Page Cluster Spacing" (Settings > Application, saved as `charge`, -1 tight ... -100 loose) is the d3 repulsion strength of the grid's real-time bubbles. The
// density cloud and the zoomed card lay dots on a fixed honeycomb instead, so they have to be told how far apart the real bubbles would sit.
//
// MEASURED 2026-10-16 (the grid's own forces - collide(r) + manyBody(charge) + a 0.3 pull to one target - run headless in d3-force for 400 ticks, mean
// nearest-neighbour distance in px): the distance depends on the charge and NOT on how many bubbles there are or how big they are, as long as the repulsion
// dominates (at the default it is just twice the radius).
//
//   |charge|   1     10    30     60     100
//   spacing    8.0   9.6   16.3   23.5   30.5   (the same at 5, 20 and 60 bubbles, radius 4 and 7)
//
// Between those points it is interpolated linearly. A cloud still tightens to fit its box when it is crowded, exactly as before; this only sets how loose it
// may be when there is room.
const MEASURED: Array<[number, number]> = [
  [1, 8.0],
  [10, 9.6],
  [30, 16.3],
  [60, 23.5],
  [100, 30.5],
];

export const clusterSpacingForCharge = (charge: unknown): number => {
  const c = Math.abs(Number(charge));
  if (!Number.isFinite(c) || c <= MEASURED[0][0]) {
    return MEASURED[0][1];
  }
  if (c >= MEASURED[MEASURED.length - 1][0]) {
    return MEASURED[MEASURED.length - 1][1];
  }
  for (let i = 1; i < MEASURED.length; i++) {
    const [c1, s1] = MEASURED[i];
    if (c <= c1) {
      const [c0, s0] = MEASURED[i - 1];

      return s0 + ((c - c0) / (c1 - c0)) * (s1 - s0);
    }
  }

  return MEASURED[0][1];
};
